package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2024_03_01_Day_1() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We rejoin our heroes who had just brought a calmed, but still evil, Dolly (holder of the “compound eye”) back to her room after a brief chase and scuffle.  Dolly proclaims that the heroes have “no idea what powers [they] are messing with.” More fighting commences. In the heat of battle, Caper is able to persuade her. Annette grabs the gem and leaves the room. The heroes decide to leave town.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes are able to travel about 3 hours towards Cark before sunset. During the night watch, Dirk sees a green dragon south of where the heroes are camping.")
    }
}
